import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import AddFood from "./components/AddFood";
import AddIngredient from "./components/AddIngredients";
import IngredientsAddImage from "./components/IngredientsAddImage";
import Home from "./components/Home";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import AddImage from "./components/AddImage";
import { UserAuthContextProvider } from "./context/UserAuthContext";
import NewFoodListWrapper from "./components/NewFoodListWrapper";
import AddFoodFromAsko from "./components/AddFromAsko";

function App() {
    return (
        <Container className="masterContainer">
            <Row>
                <Col>
                    <UserAuthContextProvider>
                        <Routes>
                            <Route
                                path="/home"
                                element={
                                    <ProtectedRoute>
                                        <Home />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/newFoods"
                                element={
                                    <ProtectedRoute>
                                        <NewFoodListWrapper />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/" element={<Login />} />
                            <Route
                                path="/add"
                                element={
                                    <ProtectedRoute>
                                        <AddFood />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addIngredient"
                                element={
                                    <ProtectedRoute>
                                        <AddIngredient />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addIngredientImage"
                                element={
                                    <ProtectedRoute>
                                        <IngredientsAddImage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addFromAsko"
                                element={
                                    <ProtectedRoute>
                                        <AddFoodFromAsko />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/addImage"
                                element={
                                    <ProtectedRoute>
                                        <AddImage />
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </UserAuthContextProvider>
                </Col>
            </Row>
        </Container>
    );
}

export default App;
